<template>
  <div style="background-color: rgb(247, 248, 249); width: 100vw;text-align: center;"
    class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div class="code">
      <img :src="'https://www.cdjjwang.com/' + this.teacehrcode" alt="">
      <!-- <div>扫码添加微信 快速匹配老师</div> -->
      <div>{{ tip }}</div>
    </div>
    <div style="background-color: #fff;">
      <el-carousel width="7.2917rem" height="3.3333rem" id="first">
        <el-carousel-item v-for="item in lunbo" :key="item.ciid">
          <img :src="'https://www.cdjjwang.com/' + item.image" alt="" style="width: 100%;height: 100%;"
            @click="openNewTab(item.url)">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="ft">
      <div class="title">高中</div>
      <div class="flex">
        <div class="flex">
          <div class="box" v-for="item in teachers.slice(6, 9)">
            <div class="inner">
              <div class="left">
                <img :src="'https://www.cdjjwang.com/' + item.avatar" alt="">
                <div class="name">{{ item.name }}</div>
              </div>
              <div class="right">
                <div class="time"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{ item.classHours }}h
                </div>
                <div class="card">
                  <div>{{ item.university }}</div>
                  <div>{{ teachertype[item.collegeStudentGrade] }}</div>
                </div>
                <div class="txt">{{ item.selfEvaluation }}</div>
                <button v-if="ifteacher" @click="$router.push({ path: '/studentlook', hash: item.tid });">查看详情</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ft">
      <div class="title">初中</div>
      <div class="flex">
        <div class="box" v-for="item in teachers.slice(3, 6)">
          <div class="inner">
            <div class="left">
              <img :src="'https://www.cdjjwang.com/' + item.avatar" alt="">
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="right">
              <div class="time"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{ item.classHours }}h
              </div>
              <div class="card">
                <div>{{ item.university }}</div>
                <div>{{ teachertype[item.collegeStudentGrade] }}</div>
              </div>
              <div class="txt">{{ item.selfEvaluation }}</div>
              <button v-if="ifteacher" @click="$router.push({ path: '/studentlook', hash: item.tid });">查看详情</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ft">
      <div class="title">小学</div>
      <div class="flex">
        <div class="box" v-for="item in teachers.slice(0, 3)">
          <div class="inner">
            <div class="left">
              <img :src="'https://www.cdjjwang.com/' + item.avatar" alt="">
              <div class="name">{{ item.name }}</div>
            </div>
            <div class="right">
              <div class="time"><img src="../../assets/indexFTboxtimer.png" alt="">累计授课{{ item.classHours }}h
              </div>
              <div class="card">
                <div>{{ item.university }}</div>
                <div>{{ teachertype[item.collegeStudentGrade] }}</div>
              </div>
              <div class="txt">{{ item.selfEvaluation }}</div>
              <button v-if="ifteacher" @click="$router.push({ path: '/studentlook', hash: item.tid });">查看详情</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="parent">
      <img src="../../assets/indexfankuititle.png" style="width: 3.67rem;height: auto;margin-top: .520rem;" alt="">
      <template>
        <el-carousel :interval="40000" type="card" height="2.1875rem" width="7.2917rem" id="parent">
          <el-carousel-item v-for="item in fankui" :key="item.ceid">
            <div class="box">
              <div class="inner">
                <div class="left">
                  <div class="title">
                    <img src="../../assets/indexPmessage.png" alt="">{{ item.parent }}<span>{{ studyitems[item.item]
                      }}</span>
                  </div>
                  <div class="txt">{{ item.estimation }}
                  </div>
                </div>
                <div class="right"><img :src="'https://www.cdjjwang.com/' + item.image" alt=""></div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div class="why"><img src="../../assets/indexwhy.png" style="width: 3.125rem;height: 2.776rem;" alt=""></div>
    <div class="counseling">
      <img src="../../assets/counselingtitle.png" alt="" style="width: 3.6719rem;height: .4323rem;">
      <div class="box">
        <div class="inner" v-for="item in counseling" :key="item.caid">
          <div @click="pushcounseling(item.type)">
            <div class="title">{{ typelist[parseInt(item.type - 1)] }}</div>
            <div class="son">
              <img :src="'https://www.cdjjwang.com/' + item.image" alt="">
              <div class="txt">{{ item.article }}</div>
            </div>
          </div>

        </div>
      </div>
      <div style="width: 100vw;height: .6771rem;"></div>
    </div>
    <div class="indexbottom">
      <div class="txt">
        <div class="box">
          <div class="title">我是家长</div>
          <div v-for="item in woshijiazhang" @click="openNewTab(item.link)">{{ item.title }}</div>

        </div>
        <div class="box">
          <div class="title">我是老师</div>
          <div v-for="item in woshilaoshi" @click="openNewTab(item.link)">{{ item.title }}</div>
        </div>
        <div class="box">
          <div class="title">关于我们</div>
          <div v-for="item in guanyuwomen" @click="openNewTab(item.link)">{{ item.title }}</div>

        </div>
      </div>
      <div>
        <img src="../../assets/logo2.png" style="width: .651rem;height: .651rem;margin-top: .2396rem;" alt="">
        <div> <img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" alt=""
            style="width: 0.08rem;height: 0.08rem;transform: translateY(.015rem);"><a class="beian" style="color:#000;"
            href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2021023060号</a>
        </div>

      </div>

      <div class="er">
        <img src="../../assets/gongzhonghao.jpg" alt="" style="width: .5208rem;height: .5208rem;">
        <div class="text">扫码关注公众号 获取更多信息</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      asses: [],
      ifteacher: true,
      woshijiazhang: [],
      woshilaoshi: [],
      guanyuwomen: [],
      teacehrcode: '',
      fankui: [],
      tip: '',
      studyitems: {
        10: '小学全科',
        11: '小学语文',
        12: '小学奥数',
        13: '小学数学',
        14: '小学英语',
        15: '小学作业辅导',
        20: '初中全科',
        21: '初中语文',
        22: '初中英语',
        23: '初中数学',
        24: '初中物理',
        25: '初中化学',
        30: '高中数学',
        31: '高中语文',
        32: '高中英语',
        33: '高中物理',
        34: '高中化学',
        35: '高中生物',
        36: '高中历史',
        37: '高中政治',
        38: '高中地理',
        40: '法语',
        41: '德语',
        42: '西班牙语',
        43: '日语',
        44: '葡萄牙语',
        45: '韩语',
        50: '音乐',
        51: '美术',
        52: '舞蹈',
        53: '体育',
        54: '体育',
        60: '其他'
      },
      teachers: [],
      teachertype: ['专职教师', '在读本科生', '在读研究生'],
      counseling: [],
      typelist: ['政策解读', '学君小课堂', '成长心理学'],
      lunbo: [],
      classhour: '',
      Authorization: ''
    }
  },

  created() {
    if (localStorage.getItem('identity') == 0) {
      this.ifteacher = false
    }

    this.Authorization = localStorage.getItem('Authorization');
    this.$http.get('/Api/Web/Config/Online', {
      headers: {
        'Authorization': localStorage.getItem('Authorization')
      }
    }).then(res => {
      if (this.ifteacher == false) {
        this.teacehrcode = res.data.data[1].qrcode
        this.tip = '扫码添加微信 获取家教资源'

      }
      else {
        this.teacehrcode = res.data.data[0].qrcode
        this.tip = '扫码添加微信 快速匹配老师'

      }

    })
    this.$http.get('/Api/Web/Config/Footer', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      this.woshijiazhang = res.data.data.footerList1.filter(item => item !== null)
      this.woshilaoshi = res.data.data.footerList2.filter(item => item !== null)
      this.guanyuwomen = res.data.data.footerList3.filter(item => item !== null)

    })
    this.$http.get('/Api/Web/Config/Estimations', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      this.fankui = res.data.data.filter(item => item !== null)
    });
    this.$http.get('/Api/Web/Config/Teachers', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      this.teachers = res.data.data.records.slice(8, 17).filter(item => item !== null)
    })
    this.$http.get('/Api/Web/Config/Web/Articles', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      console.log(res);
      this.counseling = res.data.data.filter(item => item !== null)
    })
    this.$http.get('/Api/Web/Config/Images', {
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      let arr = []
      res.data.data.slice(-6).forEach(element => {
        if (element.url !== null) {
          arr.push(element)
        }
      });
      this.lunbo = arr
    })
  },
  methods: {
    openNewTab(url) {
      window.open(url);
    },
    pushcounseling(type) {
      console.log(type);
      this.$router.push({ path: '/nocounseling?type=' + type });
    }
  }
}
</script>

<style>
.beian {
  text-decoration: none;
  color: #000;
  font-size: 12px;
}

#first {
  height: 650px;
  width: 1400px;
  margin: 0 auto;
  margin-top: 24px;
  overflow: hidden;
}

.code {
  position: fixed;
  top: 720px;
  left: 1687px;
  width: 180px;
  height: 230px;
  background: rgb(255, 255, 255);
  box-shadow: 4px 8px 12px rgba(0, 0, 0, 0.18);
}

.code img {
  width: 140px;
  height: 140px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 10px;

}

.code div {
  /* 扫码添加微信 快速匹配老师 */
  width: 120px;
  height: 52px;
  color: rgb(0, 0, 0);
  font-family: 微软雅黑;
  font-size: 20px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 30px;
}



.ft .title {
  background: url('../../assets/indexFTtitle.png');
  width: 440px;
  height: 63px;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 94px;
  /* 高 中 */

  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 15px;
  text-align: left;
  padding-left: 204px;
  padding-top: 15px;
  box-sizing: border-box;
}

.ft .flex {
  display: flex;
  width: 1400px;
  height: 283px;
  margin: 0 auto;
  justify-content: space-between;
  margin-top: 35px;
}

.ft .flex .box {
  width: 430px;
  height: 300px;
  background: url('../../assets/indexFTboxbg.png');
  background-size: 100% 100%;
}

.ft .flex .box .inner {
  display: flex;
  width: 360px;
  height: 212px;
  margin: 0 auto;
  margin-top: 50px;
  justify-content: space-between;
}

.ft .flex .box .inner .left img {
  width: 120px;
  height: 180px;
}

.ft .flex .box .inner .left .name {
  /* tag/default/default/plain/off (style) */
  width: 120px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  margin-top: 8px;
  /* 弗拉基米·伊里奇 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  letter-spacing: 1px;
}

.ft .flex .box .inner .right {
  width: 224px;
  height: 212px;
}

.ft .flex .box .inner .right .time {
  width: 140px;
  height: 24px;
  box-sizing: border-box;
  border: 1px solid rgb(1, 162, 153);
  border-radius:
    2px;
  /* 累计授课1145h */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;
}

.ft .flex .box .inner .right .time img {
  width: 12px;
  height: 14px;
  transform: translateY(2px);
  margin-right: 5px;
}

.ft .flex .box .inner .right .card {
  width: 224px;
  height: 20px;
  display: flex;
  gap: 8px;
  overflow: hidden;
  flex-wrap: wrap;
  margin-top: 10px;
}

.ft .flex .box .inner .right .card div {
  width: auto;
  height: 24px;
  padding-left: 5px;
  padding-right: 5px;
  /* 下北泽大学 */
  color: rgb(1, 162, 153);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  background: rgb(207, 242, 240);
  border-radius:
    2px;

}

.ft .flex .box .inner .right .txt {
  /* 矩形 32 */
  width: 224px;
  height: 108px;
  background: rgb(255, 255, 255);
  border: 1px dashed rgb(205, 208, 214);
  border-radius:
    2px;
  margin-top: 9px;
  padding: 4px 7px 4px 7px;
  color: rgb(96, 98, 102, 0.85);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  /* 限制在3行内 */
  overflow: hidden;

}

.ft .flex .box .inner .right button {
  width: 80px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 144px;
  margin-top: 8px;
}

.parent .title {
  /* 家长反馈 */
  margin: 0 auto;
  width: 80px;
  height: 28px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 100px;
}


.parent #parent {
  width: 1400px;
  height: 483px;
  margin: 0 auto;
  margin-top: 30px;
  overflow: hidden;
}

.parent #parent .box {
  width: 720px;
  height: 420px;
  background: url('../../assets/indexFTboxbg.png') no-repeat center;
  background-size: 100% 100%;
  padding-top: 50px;
  padding-left: 75px;

}

#parent .el-carousel__item--card.is-in-stage {
  filter: brightness(0.8);

}

#parent .el-carousel__item--card.is-active {
  z-index: 2;
  filter: brightness(1);
}


.parent #parent .box .inner {
  width: 570px;
  height: 320px;
  display: flex;
  justify-content: space-between;
}

.parent #parent .box .inner .left {
  height: 258px;
  width: 360px;
  padding-top: 42px;
}

.parent #parent .box .inner .left .title {
  width: 360px;
  height: 40px;
  background: rgb(240, 242, 245);
  margin-top: 0;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: justify;
}

/deep/.el-carousel__indicators--outside button {
  background-color: #C0C4CC;
  opacity: .29;
}

.parent #parent .box .inner .left .title img {
  transform: translate(8px, 8px);
  margin-right: 15px;
}

.parent #parent .box .inner .left .title span {
  display: inline-block;
  margin-left: 20px;

}

.parent #parent .box .inner .left .txt {
  width: 360px;
  height: 180px;
  border: 1px dashed rgb(205, 208, 214);
  border-radius:
    2px;
  margin-top: 38px;
  padding: 7px 11px 7px 11px;
  /* 我家孩子数学成绩本来只有80来分，多亏了张老师的一对—上门家教，补了—个学期，中考考了130多，一直以为他是脑子笨学不好，请了家教之后张老师给他做了专门的分析，原来是之前的老师教学方法不适合他。谢谢张老师!谢谢学君教育的为我们匹配到了张老师! */
  color: rgb(96, 98, 102, 0.7);
  font-family: 苹方;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: justify;



}

.parent #parent .box .inner .right img {
  width: 160px;
  height: 320px;
}

.why {
  width: 100vw;
  text-align: center;
  padding-top: 40px;
  background-color: rgb(255, 255, 255);
}

.counseling {
  width: 100vw;
  text-align: center;
  padding-top: 80px;
}

.counseling .box {
  width: 1400px;
  height: 335px;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 50px;
}

.counseling .box .inner {
  width: 420px;
  height: 335px;
}

.counseling .box .inner .title {
  /* 政策解读 */
  width: 100px;
  height: 28px;
  position: relative;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 15.5px;
}

.counseling .box .inner .title::before {
  content: '';
  position: absolute;
  width: 10px;
  height: 10px;
  background: rgb(176, 0, 32);
  top: 12px;
  left: -15px;
}

.counseling .box .inner .title::after {
  content: '';
  background: url('../../assets/counselingarrow.png') no-repeat;

  position: absolute;
  width: 24px;
  height: 24px;
  left: 110px;
  top: 3px;

}

.counseling .box .inner .son {
  width: 440px;
  height: 320px;
  background: url('../../assets/indexFTboxbg.png') no-repeat;
  background-size: 100% 100%;
  transform: translateX(-14px);
}

.counseling .box .inner .son img {
  width: 360px;
  height: 224px;
  margin-top: 26px;
  margin-left: 7px;
}

.counseling .box .inner .son .txt {
  /* 好消息:2023年成都体育中考体考长跑免考，单项全部计满分! */
  width: 360px;
  height: 44px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 44px;
  margin-top: 3px;
}

.indexbottom {
  width: 100vw;
  height: 280px;
  background-color: #C4C4C4;
  display: flex;
}

.indexbottom .txt {
  width: 600px;
  height: 121px;
  margin-left: 556px;
  margin-top: 50px;
  display: flex;
}

.indexbottom .txt .box {
  width: 200px;
  height: 121px;
}

.indexbottom .txt .box .title {
  height: 25px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 20px;
  font-weight: 600;
  line-height: 25px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 15px;


}

.indexbottom .txt .box div {
  /* 如何找到合适的老师 */
  height: 21px;
  color: rgb(0, 0, 0);
  font-family: 苹方;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
}

.indexbottom .er {
  width: 120px;
  height: 150px;
  margin-top: 46px;
  margin-left: 90px;
}

.indexbottom .er .text {
  /* 扫码关注公众号 获取更多信息 */
  width: 112px;
  height: 42px;
  color: rgb(0, 0, 0);
  font-family: 微软雅黑;
  font-size: 16px;
  font-weight: 290;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
  margin-top: 6px;

}
</style>


// WEBPACK FOOTER //
// src/components/layout/banner.vue